export default class Perfil {
	pk;
	nome;
	isAdmin;
	isManager;

	constructor({
		pk,
		nome,
		isAdmin,
		isManager,
	}) {
		this.pk = pk;
		this.nome = nome;
		this.isAdmin = isAdmin;
		this.isManager = isManager;
	}

	static fromMap(map) {

		if (!map) {
			return map;
		}

		return new Perfil({
			...map,
			isAdmin: map.is_admin,
			isManager: map.is_manager
		});
	}
}
